import PageMyReservation from "@/views/PageMyReservation.vue"
import PageSearchReservation from "@/views/PageSearchReservation.vue"
import PageMyReservationInfo from "@/views/PageMyReservationInfo.vue"
import PageMyReservationTempForm from "@/views/PageMyReservationTempForm.vue"
import PageGuardReservationMain from "@/views/guard/PageGuardReservationMain.vue"
import PageGuard1 from "@/views/guard/PageGuard1.vue"
import PageGuard2 from "@/views/guard/PageGuard2.vue"
import PageGuard3 from "@/views/guard/PageGuard3.vue"
import PageGuardAll from "@/views/guard/PageGuardAll.vue"
import PageGuardReservationReleaseList from "@/views/guard/PageGuardReservationReleaseList.vue"
import PageGuardReservationReleaseInfo from "@/views/guard/PageGuardReservationReleaseInfo.vue"

export default [
  {
    path: "/MyReservation",
    name: "PageMyReservation",
    component: PageMyReservation,
  },
  {
    path: "/MyReservationInfo",
    name: "PageMyReservationInfo",
    component: PageMyReservationInfo,
    props: true,
  },
  {
    path: "/MyReservationTempForm",
    name: "PageMyReservationTempForm",
    component: PageMyReservationTempForm,
    props: true,
  },

  {
    path: "/SearchReservation",
    name: "PageSearchReservation",
    component: PageSearchReservation,
    props: true,
  },
  {
    path: "/GuardMain",
    name: "PageGuardReservation",
    component: PageGuardReservationMain,
  },
  {
    path: "/PageGuard1",
    name: "PageGuardReservation_entering",
    component: PageGuard1,
    props: true,
  },
  {
    path: "/PageGuard2",
    name: "PageGuardReservation_in1",
    component: PageGuard2,
    props: true,
  },
  {
    path: "/PageGuard3",
    name: "PageGuardReservation_in2",
    component: PageGuard3,
    props: true,
  },
  {
    path: "/PageGuardAll",
    name: "PageGuardReservation_all",
    component: PageGuardAll,
    props: true,
  },
  {
    path: "/PageGuardReservationReleaseList",
    name: "PageGuardReservationReleaseList",
    component: PageGuardReservationReleaseList,
    props: true,
  },
  {
    path: "/PageGuardReservationReleaseInfo",
    name: "PageGuardReservationReleaseInfo",
    component: PageGuardReservationReleaseInfo,
    props: true,
  },
]
